module.exports = __webpack_public_path__ + "b69ab305dabcf66355ea404e448bd89e.svg";